import { Link } from 'react-router-dom';
import { ArrowDown, ArrowUpRight } from 'lucide-react';
import EstateExplorer from '@/components/EstateExplorer';
import FragmentLink from '@/components/FragmentLink';

const DOORS = [
  { to: '/upgrades', title: 'Upgrades', text: 'Plan and validate the next release.' },
  { to: '/migrations', title: 'Migrations', text: 'Move workloads. Preserve what matters.' },
  { to: '/support', title: 'Support retainers', text: 'An engineer who knows your estate.' },
  { to: '/notes', title: 'Field notes', text: 'Practical detail from the work.' },
];

export default function MotifHero() {
  return (
    <section className="on-forest home-hero">
      <div className="container">
        <div className="home-hero__grid">
          <div className="home-hero__copy">
            <p className="experience-eyebrow">Oracle WebCenter specialists</p>
            <h1>Your WebCenter<br />estate, in<br /><span>expert hands.</span></h1>
            <p className="home-hero__lead">Nearly 25 years of Oracle WebCenter delivery. Upgrades, migrations and support for the documents, invoice workflows and ERP connections your business depends on.</p>
            <p className="home-hero__promise">Protect the investment you have made.<br />Move forward on your timeline.</p>
            <div className="home-hero__actions">
              <Link to="/contact" className="btn-cream">Talk to us <ArrowUpRight size={18} aria-hidden="true" /></Link>
              <Link to="/upgrades" className="home-text-link">Explore the upgrade program <ArrowUpRight size={17} aria-hidden="true" /></Link>
            </div>
            <FragmentLink hash="#your-next-move" className="home-hero__scroll"><ArrowDown size={15} aria-hidden="true" /> Find your next move</FragmentLink>
          </div>
          <EstateExplorer />
        </div>
        <nav className="home-doors" aria-label="Four doors into the practice">
          {DOORS.map((door, i) => <Link key={door.to} to={door.to}><span className="home-doors__number">0{i + 1}</span><h2>{door.title}<ArrowUpRight size={19} aria-hidden="true" /></h2><p>{door.text}</p></Link>)}
        </nav>
      </div>
    </section>
  );
}
